import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type ApplicationFilter } from '../../../Assessment/graphql';
import { type MappingType } from '../../../Nomination/components/constant';
import { FundingSource } from '../../../Nomination/components/NominationForm/FundingModule/types';

const GET_DSRC_ASSESSMENT_ID = gql`
  query ($applicationId: String!, $filter: NominationFilter!) {
    nominations(filter: $filter) {
      shouldScholarshipNominationPerformed
      fundings {
        source
        schema
      }
    }

    assessmentDetail(applicationId: $applicationId) {
      dsrcAdmissionForm {
        _id
      }
      dsrcAssessment {
        _id
      }
    }
  }
`;

type DsrcAssessment = {
  dsrcAdmissionId: string;
  dsrcAssessmentId: string;
};

type GetDsrcAssessment = {
  dsrcAssessmentId: DsrcAssessment;
  recommendForHKPFS: boolean;
  fundingSchemas: Array<{ schema: MappingType }>;
  isUPAF: boolean;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetDsrcAssessmentID = (
  id: string,
  filter: ApplicationFilter,
): GetDsrcAssessment => {
  const { data, loading, error } = useQuery(GET_DSRC_ASSESSMENT_ID, {
    variables: { applicationId: id, filter },
    fetchPolicy: 'network-only',
  });

  const dsrcAssessmentId = {
    dsrcAdmissionId: data?.assessmentDetail?.dsrcAdmissionForm?._id ?? '',
    dsrcAssessmentId: data?.assessmentDetail?.dsrcAssessment?._id ?? '',
  };

  const fundingSchemas: Array<{ schema: MappingType }> =
    data?.nominations?.[0]?.fundings ?? [];

  const recommendForHKPFS: boolean = fundingSchemas?.some(
    (funding: any) =>
      funding?.source === FundingSource.HONGKONG_PHD_FELLOWSHIP_SCHEME,
  );
  const isUPAF =
    data?.nominations?.[0]?.shouldScholarshipNominationPerformed ?? false;

  return {
    dsrcAssessmentId,
    fundingSchemas,
    recommendForHKPFS,
    isUPAF,
    loading,
    error,
  };
};
